/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: 倪国晓
 * @Date: 2022-10-11 14:30:47
 * @LastEditors: 倪国晓
 * @LastEditTime: 2022-10-25 15:07:35
 */
import ColumnTypes from '@/utils/ColumnTypes';
import { DrInfo, TzInfo,  DrContacts } from './renderHeader';
// 达人信息
const talentInfo = {
	key: 'talentInfo',
	type: () => import('./tableCell/drInfoCell'),
	renderHeader: DrInfo,
	width: '400',
};
//达人联系人
const talentContacts = {
	key: 'talentContacts',
	type: () => import('./tableCell/drContactsCell'),
	renderHeader: DrContacts,
	width: '400',
};

//团长信息
const tzInfo = {
	label: '团长信息',
	key: 'institution_name',
	type: ColumnTypes.TextCell,
	renderHeader: TzInfo,
	width: '400',
};
//关联达人
const relatedTalent = {
	label: '关联达人',
	key: 'relatedTalent',
	type: () => import('./tableCell/relativedDr'),
	width: '400',
};
//操作
const operation = {
	label: '操作',
	key: 'operation',
	type: ColumnTypes.ButtonsCell,
	width: '100',
};
export const talentColumns = [talentInfo, talentContacts, operation]; //达人
export const tzColumns = [tzInfo, relatedTalent, operation]; //团长
